export default __webpack_public_path__ + "media/images/brands/expmessenger/other/merry_christmas-5aab7e014e633d758900b6d6c459965c.jpg";